import React from 'react';
import './cohort-list.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faMagnifyingGlass, faPen, faRibbon, faUserAstronaut, faUsers, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';

const CohortList = ({
    cohorts
}) => {

    const navigate = useNavigate();
    const location = useLocation();

    return (    
        <div className='cohort-list'>
            <table className='g-table'>
                <thead>
                    <tr>
                        <th></th>
                        <th>Name</th>
                        <th>Organization</th>
                        {
                            (location && location.pathname.includes('/admin/')) &&
                            <th className='center'>Admin</th>
                        }
                        <th className='center'>Participants</th>
                        <th className='center'>MCs</th>
                        <th></th>
                    </tr>
                </thead>
                {
                    (cohorts) &&
                    <tbody>
                        {
                            Object.values(cohorts)
                            .sort((a,b) => a.name > b.name ? 1 : -1)
                            .map(c => {
                                return (
                                    <tr key={c.id}>
                                        <td >
                                            <img src={c.icon} className='cohort-icon' />
                                        </td>
                                        <td>{c.name}</td>
                                        <td>{c.org}</td>
                                        {
                                            (location && location.pathname.includes('/admin/')) &&
                                            <td className='center'>{c.adminList ? c.adminList.length : 0}</td>
                                        }
                                        <td className='center'>{c.userList ? c.userList.length : 0}</td>
                                        <td className='center'>{c.mcList ? c.mcList.length : 0}</td>
                                        <td>
                                            <div className='buttons'>
                                                {
                                                    (location && location.pathname.includes('/admin/')) &&
                                                    <>
                                                        <button 
                                                            className='g-button small-btn'
                                                            onClick={() => navigate(`edit/${c.path}`)}
                                                            title='Edit Cohort' >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        <button 
                                                            className='g-button small-btn'
                                                            onClick={() => navigate(`manageadmin/${c.path}`)}
                                                            title='Manage Cohort Admin' >
                                                            <FontAwesomeIcon icon={faUserTie} />
                                                        </button>
                                                        <button 
                                                            className='g-button small-btn'
                                                            onClick={() => navigate(`users/${c.path}`)}
                                                            title='Manage Users'>
                                                            <FontAwesomeIcon icon={faUsers} />
                                                        </button>
                                                        <button 
                                                            className='g-button small-btn'
                                                            onClick={() => navigate(`mcs/${c.path}`)}
                                                            title='Manage Micro-Credentials'>
                                                            <FontAwesomeIcon icon={faAward} />
                                                        </button>
                                                    </>
                                                }
                                                <button 
                                                    className='g-button med-btn'
                                                    onClick={() => navigate(`view/${c.path}`)}
                                                    title='View Cohort Progress'>
                                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                }

            </table>
        </div>
    )
}

export default CohortList